import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      baseData: {}
    };
  },
  methods: {
    init: function init(id) {
      var _this = this;
      this.dialogVisible = true;
      this.loading = true;
      this.baseData = {};
      this.$http({
        url: "/web/operate_record/showDetails?id=".concat(id)
      }).then(function (res) {
        _this.baseData = res.data || {};
      }).finally(function () {
        _this.loading = false;
      });
    }
  }
};